// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__zQO8R","loaderOuter":"PageOverlayLoader_loaderOuter__2MV0T"};